var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',{attrs:{"value":_vm.value,"enable-cross":false,"min-range":1,"tooltip-formatter":_vm.formatter},on:{"change":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }